<template>
  <div class="no-products container">
    <h1>No Products</h1>
    <p>
      This collection is unfortunately empty, please have a look at some of our
      other collections
    </p>
  </div>
</template>

<style lang="scss" scoped>
.no-products {
  padding-bottom: 60px;

  @include respond-above(md) {
    padding-bottom: 60px;
  }

  h1 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 10px;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  p {
    font-family: $heading-font-family;
    font-size: 14px;

    @include respond-above(md) {
      font-size: 18px;
    }
  }
}
</style>
